import { render } from "./ListInvoicesComponent.vue?vue&type=template&id=5b52e0ae&scoped=true"
import script from "./ListInvoicesComponent.vue?vue&type=script&lang=js"
export * from "./ListInvoicesComponent.vue?vue&type=script&lang=js"

import "./ListInvoicesComponent.vue?vue&type=style&index=0&id=5b52e0ae&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/dev.soft.team/www/autoringen2/autoringen2.dev.soft.team/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b52e0ae"],['__file',"resources/themes/default/js/components/invoices/ListInvoicesComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b52e0ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b52e0ae', __exports__)) {
    console.log('reload')
    api.reload('5b52e0ae', __exports__)
  }
  
  module.hot.accept("./ListInvoicesComponent.vue?vue&type=template&id=5b52e0ae&scoped=true", () => {
    console.log('re-render')
    api.rerender('5b52e0ae', render)
  })

}


export default __exports__